import React from 'react';
import { Collapse as AntdCollapse } from 'antd';
import { ChevronDownCollapse } from 'common/all-icons/custom-icons';
import styles from './Collapse.module.scss';
import cx from 'clsx';

const Collapse = ({
  accordion = false,
  activeKey = '',
  defaultActiveKey = '',
  bordered = true,
  destroyOnHidden = false,
  collapsible = '',
  expandIconPosition = 'end',
  onChange = () => {},
  items = [],
  outerClassName = '',
}) => {
  return (
    <div className={cx(styles.collapseContainer, outerClassName)}>
      <AntdCollapse
        accordion={accordion}
        bordered={bordered}
        destroyOnHidden={destroyOnHidden}
        expandIconPosition={expandIconPosition}
        items={items}
        onChange={onChange}
        defaultActiveKey={defaultActiveKey}
        {...(activeKey ? { activeKey: activeKey } : {})}
        {...(collapsible ? { collapsible: collapsible } : {})}
        expandIcon={({ isActive }) => (
          <ChevronDownCollapse style={{ transform: !isActive ? 'rotate(180deg)' : 'rotate(0)' }} />
        )}
      />
    </div>
  );
};

export default Collapse;
